import translations from 'Translations';
import errorTypes from 'Misc/error-types';

const errorMessage = (errorType, appName) => {
  if (errorType === errorTypes.geoblock) {
    return translations[appName].errorGeoblock
  }
  return translations[appName].error;
};

export default errorMessage;


// WEBPACK FOOTER //
// ./src/misc/error-message/index.js